/**
 * THE cursor rule for every Gantt chart (crew, the gag panel's task Gantt, the
 * Breakdown Timeline, hires) — owner ruling 2026-10-11: "one shared rule for
 * all four charts".
 *
 *   hovering over …                          cursor
 *   the chart background (a drag PANS it)    grab          GANTT_CURSOR.pan
 *   a thing a drag MOVES (bar, marker)       move          GANTT_CURSOR.move
 *   an edge a drag RESIZES                   col-resize    GANTT_CURSOR.resize
 *   a thing that only opens on click         pointer       GANTT_CURSOR.open
 *
 * 🔑 WHY `move` AND NOT `grab` ON A MOVABLE THING. The background already shows
 * `grab` (drag-to-pan, `hooks/useDragScroll.js`), and until this rule every
 * draggable bar and marker showed `grab` too — so hovering one changed nothing
 * and nothing said "this one moves a date" (owner: "the cursor is the same for
 * when we are hovering over dragable object"). The two gestures must not share
 * a cursor. While a PAN is live `index.css` forces `grabbing` everywhere.
 *
 * Values for an inline `style={{ cursor }}`; `GANTT_CURSOR_CLASS` holds the
 * same rule as Tailwind classes (written out in full — the content scanner
 * needs literal class names). Each chart still decides WHICH state an element
 * is in; this file only says what that state looks like.
 *
 * 🕶️ jsdom shows no cursor. A test can pin that an element asks for the right
 * one; that it reads well under a real pointer is a browser check.
 */
export const GANTT_CURSOR = Object.freeze({
  pan: 'grab',
  move: 'move',
  resize: 'col-resize',
  open: 'pointer',
});

export const GANTT_CURSOR_CLASS = Object.freeze({
  pan: 'cursor-grab',
  move: 'cursor-move',
  resize: 'cursor-col-resize',
  open: 'cursor-pointer',
});
